import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { createList, setList, goToList } from '../Actions/Favourites.action';
import constants from '../constants';
import Tippy from '@tippyjs/react';

class FavouritesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listId: constants.selectedFavouriteListId ,
            listName: "",
            openCreate: false,
            showInfo: false,
            errors: {},
            result: {},
            lists: constants.favouriteLists
        }
    }

    componentDidMount() {
        if (!this.props || !this.props.favourites) {
            return;
        }
    }
    componentDidUpdate() {
        const { favourites } = this.props;
        if (!favourites.errors) {
            return;
        }
    }

    handleSetList(id) {
        this.setState({
            listId: id
        });
    }

    handleSetListToUse(id) {
        this.props.setList(id).then(result => {
            location.reload();
        });
    }
    handleGoToList(id) {
        this.props.goToList(id).then(result => {
            location.href = constants.favouritesPageUrl;
        });
    }

    handleSetListName(value) {
        this.setState({
            listName: value
        });
    }

    handleOpenCreate() {
        this.setState({
            openCreate: !this.state.openCreate
        });
    }
    handleCreate() {
        this.props.createList(this.state.listName).then(lists => {
            this.setState({
                ...this.state,
                lists: lists
            });
        });
    }
    toggle() {
        this.setState({ showInfo: !this.state.showInfo });
    }

    render() {
        if (this.props.mobile) {
            return (
                <Fragment>
                    <div className="navbar__link favourites-wrapper" onClick={() => this.toggle()}>{translate('common.favourites.title')}</div>
                    <div className={`favourites ${!this.state.showInfo ? 'favourites--hidden' : ''}`}>
                        <div className="close-button" onClick={() => this.toggle()}></div>
                        <select value={this.state.listId} onChange={(event) => this.handleSetList(event.target.value)}>
                            <option value='' disabled>{translate('common.favourites.choose.list')}</option>
                            {this.state.lists && this.state.lists.map((list) =>
                                <option value={list.value} id={list.text} key={`favouriteList-${list.value}`}>{list.text}</option>
                            )}
                        </select>
                        <div className="favourites__buttons">
                            <button className="button favourite__button favourites__use-button" type="button" onClick={() => this.handleSetListToUse(this.state.listId)}>
                                <span className="dropzone__cart-cleararticles-title">{translate('common.favourites.use.list')}</span>
                            </button>
                            <button className="button favourite__button favourites__show-button" type="button" onClick={() => this.handleGoToList(this.state.listId)}>
                                <span className="dropzone__cart-favourites-title">{translate('common.favourites.show.list')}</span>
                            </button>
                            <button className="button favourite__button favourites__create-button" type="button" onClick={() => this.handleOpenCreate()}>
                                <span className="dropzone__clearcart-button-title">{translate('common.favourites.create.new.list.text')}</span>
                            </button>
                        </div>
                        <div className={`create-list-wrapper open-${this.state.openCreate}`}>
                            <input type="text" onChange={(event) => this.handleSetListName(event.target.value)} />
                            <Tippy
                                className="tooltip"
                                content={translate('common.favourites.tooltip.added.list')}
                                trigger="click"
                                delay={150}
                                placement="right">
                                <span className="create-list-button button" onClick={() => this.handleCreate()}>{translate('common.favourites.save.list')}</span>
                            </Tippy>
                        </div>
                    </div>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <span className="top-link__title" onClick={() => this.toggle()}>{translate('common.favourites.title')}</span>
                    <span className={`arrow-down ${this.state.showInfo ? 'arrow-up' : ''}`} onClick={() => this.toggle()}></span>
                    <div className={`favourites ${!this.state.showInfo ? 'favourites--hidden' : ''}`}>
                        <div className="close-button" onClick={() => this.toggle()}></div>
                        <select value={this.state.listId} onChange={(event) => this.handleSetList(event.target.value)}>
                            <option value='' disabled>{translate('common.favourites.choose.list')}</option>
                            {this.state.lists && this.state.lists.map((list) =>
                                <option value={list.value} id={list.text} key={`favouriteList-${list.value}`}>{list.text}</option>
                            )}
                        </select>
                        <div className="favourites__buttons">
                            <button className="button favourite__button favourites__use-button" type="button" onClick={() => this.handleSetListToUse(this.state.listId)}>
                                <span className="dropzone__cart-cleararticles-title">{translate('common.favourites.use.list')}</span>
                            </button>
                            <button className="button favourite__button favourites__show-button" type="button" onClick={() => this.handleGoToList(this.state.listId)}>
                                <span className="dropzone__cart-favourites-title">{translate('common.favourites.show.list')}</span>
                            </button>
                            <button className="button favourite__button favourites__create-button" type="button" onClick={() => this.handleOpenCreate()}>
                                <span className="dropzone__clearcart-button-title">{translate('common.favourites.create.new.list.text')}</span>
                            </button>
                        </div>
                        <div className={`create-list-wrapper open-${this.state.openCreate}`}>
                            <input type="text" onChange={(event) => this.handleSetListName(event.target.value)} />
                            <Tippy
                                className="tooltip"
                                content={translate('common.favourites.tooltip.added.list')}
                                trigger="click"
                                delay={150}
                                placement="right">
                                <span className="create-list-button button" onClick={() => this.handleCreate()}>{translate('common.favourites.save.list')}</span>
                            </Tippy>
                        </div>
                    </div>
                </Fragment>
            )
        }
    }
}


const mapStateToProps = state => {
    const { favourites } = state;
    return {
        favourites
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createList: (listId) => dispatch(createList(listId)),
        setList: (listId) => dispatch(setList(listId)),
        goToList: (listId) => dispatch(goToList(listId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FavouritesContainer);
